module.exports = __webpack_public_path__ + "media/bgmusic.77d226eb.mp3";